export default __webpack_public_path__ + "static/media/Drawing-small.27ad6cd1.jpeg";